import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PartyFilterCriteria from './PartyFilterCriteria'
import PartyList from './PartyList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PartyAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPartyDashboardPartyList } from '../../store/slice/PharmaSlice';

export default function PartyListView({setShowEdit,setPartyId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.partyDashboard);   

    const [filteredPartyList, setFilteredPartyList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { partyDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (partyDashboard.partyList.length>-1){
        setFilteredPartyList(partyDashboard.partyList);
        transformToCardFormat(partyDashboard.partyList, setCardList);
      }
    },[partyDashboard.partyList])

    useEffect(()=>{
          transformToCardFormat(filteredPartyList, setCardList);
      },[filteredPartyList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.address==='' && filterCriteria.corporateemail==='' && filterCriteria.contact==='' && filterCriteria.contactmobile==='' && filterCriteria.druglicense==='' && filterCriteria.gst==='' && filterCriteria.statusid==='' && filterCriteria.statusname==='' && filterCriteria.status==='' && filterCriteria.rejectionreason==='' ){
            setFilteredPartyList(partyDashboard.partyList);
            transformToCardFormat(partyDashboard.partyList, setCardList);

        } else {
            setFilteredPartyList(
                partyDashboard.partyList
                    .filter(party=> party.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(party=> party.contact.toString().toUpperCase().includes(filterCriteria.contact.toString().toUpperCase()))
.filter(party=> party.contactmobile.toString().toUpperCase().includes(filterCriteria.contactmobile.toString().toUpperCase()))
.filter(party=> party.statusname.toString().toUpperCase().includes(filterCriteria.statusname.toString().toUpperCase()))

                
            )
                    if (filterCriteria.status === true || filterCriteria.status === false){
                setFilteredPartyList(
                    partyDashboard.partyList.filter(party => party.status === filterCriteria.status)
                )
            }


            //transformToCardFormat(partyDashboard.filteredPartyList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PartyList
                    setShowEdit={setShowEdit}
                    setPartyId = {setPartyId}
                    tableList={filteredPartyList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}